import _isString from "lodash/isString";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import AbstractField from './AbstractField';

class ArrayField extends AbstractField {
  getDefaultWidget() {
    const {
      widgets
    } = this.props;
    return widgets.ArrayWidget;
  }

  renderErrors() {
    let {
      errors
    } = this.props;
    const {
      widgets,
      uiSchema
    } = this.props;
    const {
      ErrorWidget
    } = widgets;

    if (uiSchema['ui:widget'] === 'tagInput') {
      errors = errors.__originalValues || []; // eslint-disable-line
    }

    errors = errors.filter(error => _isString(error));
    return errors.map((error, i) => /*#__PURE__*/React.createElement(ErrorWidget, _extends({
      uiSchema: uiSchema,
      key: error,
      first: i === 0,
      last: i === errors.length - 1,
      auto: uiSchema['ui:inline']
    }, uiSchema['ui:errorProps'] || {}), error));
  }

}

export default ArrayField;